// extracted by css-extract-rspack-plugin
export default {"controlIconLight":"ControlIcon_controlIconLight__a0G6E","controlIconDark":"ControlIcon_controlIconDark__w6waD"};